import type {
  AppSaveBarEventPayload,
  AppSaveBarEventType,
} from "./app-save-bar-event.type";
import type { AppSaveBarScope } from "../app-save-bar.enum";

import { isValidObject } from "@/utilities/object";

export const getEventKey = (eventType: AppSaveBarEventType) => {
  return `app-save-bar_${eventType}`;
};

export const getEventPayload = (
  scope: AppSaveBarScope
): AppSaveBarEventPayload => {
  return { scope };
};

export const isEventPayload = (
  payload: unknown
): payload is AppSaveBarEventPayload => {
  if (!isValidObject(payload)) return false;
  if (!("scope" in payload)) return false;
  if (!(typeof payload.scope === "string")) return false;
  return payload.scope.length > 0;
};

export const isValidScope = (
  payload: unknown,
  scope: AppSaveBarScope
): payload is AppSaveBarEventPayload => {
  return isEventPayload(payload) && payload.scope === scope;
};
